import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorService } from '../../services/editor/editor.service';

@Component({
  selector: 'app-editor',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './editor.component.html',
  styleUrl: './editor.component.scss',
})
export class EditorComponent {
  _editorService = inject(EditorService);

  onTitleChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this._editorService.setDiagramTitle(target.value);
  }

  onContentChange(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this._editorService.setDiagramText(target.value);
  }
}
